import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';

import { CraigHttpInterceptor } from '@craig/core';
import { routes } from './app.routes';
import { API_ROOT_TOKEN, IS_LOCALHOST_TOKEN, ERC_LOGIN_URL_TOKEN } from './injection-tokens';

// Runtime environment detection constants
export const LOCALHOST_HOST_NAME: string = 'localhost';
export const DEV_ENV_HOST_NAME: string = 'craig.dev.parts.accuristech.com';
export const PROD_ENV_HOST_NAME: string = 'craig.parts.accuristech.com';

export const LOCALHOST_API_ROOT: string = ''; // Use proxy for localhost
export const DEV_ENV_API_ROOT: string = 'https://craig-api-d-ws.azurewebsites.net';
export const PROD_ENV_API_ROOT: string = 'https://craig-api-p-ws.azurewebsites.net';

// ERC Login URLs for session expiry / unauthorized redirects
export const DEV_ERC_LOGIN_URL: string = 'https://login.erc.accuris.dev/login/erc';
export const PROD_ERC_LOGIN_URL: string = 'https://login.ihserc.com/login/erc';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptorsFromDi()),
        provideMarkdown(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CraigHttpInterceptor,
            multi: true
        },
        { provide: Window, useValue: window },
        {
            provide: API_ROOT_TOKEN,
            useFactory: (_window: Window): string => {
                const { hostname }: Location = _window.location;

                // Runtime environment detection based on hostname
                if (hostname === LOCALHOST_HOST_NAME) {
                    return LOCALHOST_API_ROOT; // Use proxy for localhost
                } else if (hostname === PROD_ENV_HOST_NAME) {
                    return PROD_ENV_API_ROOT; // Production API
                } else {
                    return DEV_ENV_API_ROOT; // Default to dev API (covers craig.dev.parts.accuristech.com and others)
                }
            },
            deps: [Window]
        },
        {
            provide: IS_LOCALHOST_TOKEN,
            useFactory: (_window: Window): boolean => {
                const { hostname }: Location = _window.location;
                return hostname === LOCALHOST_HOST_NAME;
            },
            deps: [Window]
        },
        {
            provide: ERC_LOGIN_URL_TOKEN,
            useFactory: (_window: Window): string => {
                const { hostname }: Location = _window.location;

                // Runtime environment detection based on hostname
                if (hostname === PROD_ENV_HOST_NAME) {
                    return PROD_ERC_LOGIN_URL; // Production ERC login
                } else if (hostname === DEV_ENV_HOST_NAME) {
                    return DEV_ERC_LOGIN_URL; // Dev ERC login
                } else {
                    // For localhost, use dev ERC login
                    return DEV_ERC_LOGIN_URL;
                }
            },
            deps: [Window]
        }
    ]
};
